export default __webpack_public_path__ + "static/media/welcome-video.2bec4e19.svg";